/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Button, FormTextInput } from "../../../components";
import { colors } from "../../../configs";
import Strings from "../../../translations";

const ItemDimessionForm = (props) => {
  const {
    errorMessage,
    setMessage,
    handleChangeFormData = () => {},
    initialValue = {},
    actionType,
    handleModalClose,
  } = props;

  const [itemDimessionName, setItemDimessionName] = useState({
    value: initialValue.name ?? "",
    error: false,
    success: false,
  });

  const [description, setDescription] = useState({
    value: initialValue.description ?? "",
    error: false,
    success: false,
  });

  /** --- Handlers --- */
  const handleChangeitemDimession = (value) => {
    setMessage(null);
    setItemDimessionName(value);
  };

  const handleChangeDescription = (value) => {
    setDescription(value);
  };

  const handleSaveData = () => {
    const formData = {
      name: itemDimessionName.value,
      description: description.value,
    };
    handleChangeFormData(formData);
  };

  /** --- Strings --- */
  const CreateTitle = Strings["ItemDimession.CreateTitle"],
    EditTitle = Strings["ItemDimession.EditTitle"],
    ItemDimessionLabel = Strings["ItemDimenssion.ItemDimessionLabel"],
    ItemDimessionPlaceholder =
      Strings["ItemDimenssion.ItemDimessionPlaceholder"],
    ItemDimessionCustomError =
      Strings["ItemDimenssion.ItemDimessioneCustomError"],
    DescriptionLabel = Strings["ItemProperties.DescriptionLabel"],
    DescriptionPlaceholder = Strings["ItemProperties.DescriptionPlaceholder"],
    DescriptionCustomError = Strings["ItemProperties.DescriptionCustomError"],
    SaveBtn = Strings["ItemDimenssion.SaveBtn"],
    UpdateBtn = Strings["ItemDimenssion.UpdateBtn"],
    CancelBtn = Strings["ItemDimenssion.CancelBtn"];

  /** --- Validation --- */
  const isAddDisabled =
    itemDimessionName.error ||
    itemDimessionName.value.trim() === "" ||
    itemDimessionName.success === false ||
    itemDimessionName.value === initialValue.name;

  const isEditDisabled =
    itemDimessionName.error ||
    itemDimessionName.value.trim() === "" ||
    itemDimessionName.success === false ||
    itemDimessionName.value === initialValue.name;

  const isDisabled = actionType === "add" ? isAddDisabled : isEditDisabled;

  return (
    <div className="modalFormContainer">
      <h2>{actionType === "add" ? CreateTitle : EditTitle}</h2>

      {errorMessage && <h6 style={{ color: "red" }}>{errorMessage}</h6>}

      <FormTextInput
        type="textarea"
        label={ItemDimessionLabel}
        starProps
        placeholder={ItemDimessionPlaceholder}
        Value={itemDimessionName.value}
        onChangeText={handleChangeitemDimession}
        Validate
        CustomErrorLine={ItemDimessionCustomError}
        editable
        maxLength={30}
      />
      <FormTextInput
        type="text"
        label={DescriptionLabel}
        placeholder={DescriptionPlaceholder}
        Value={description.value}
        onChangeText={handleChangeDescription}
        Validate={false}
        CustomErrorLine={DescriptionCustomError}
        multiline
        editable
        maxLength={50}
      />
      <div style={{ display: "flex", marginTop: "1.5rem" }}>
        <Button
          buttonName={actionType === "add" ? SaveBtn : UpdateBtn}
          buttonStyle={{ backgroundColor: colors.primary }}
          disable={isDisabled}
          onClick={handleSaveData}
        />
        <Button
          buttonName={CancelBtn}
          onClick={() => {
            handleModalClose();
            setMessage(null);
          }}
          buttonStyle={{ backgroundColor: colors.darkgrey, marginLeft: "10px" }}
        />
      </div>
    </div>
  );
};

export default ItemDimessionForm;
